<template>
	<div style="width: 60%; margin: 10px auto">
		<!-- <div
			v-show="!this.$route.query.row"
			style="width: 188px;height:188px;position: absolute;top: 10vh;left: 3vw;border: #00AFFF 3px solid;box-sizing: border-box;
    border-radius: 10px;text-align: center"
		>
			<div id="qrcode" ref="qrcode" style="margin: 10px"></div>
			<br />
			扫码去手机添加
		</div> -->
		<el-form ref="form" :model="form" label-width="80px" id="myform">
			<el-form-item label="商品名称">
				<el-input v-model="form.title" placeholder="请输入商品名称"></el-input>
			</el-form-item>
			<el-form-item label="商品分类">
				<el-select v-model="form.cate" placeholder="请选择分类">
					<el-option
						v-for="item in Commodity_Category"
						:key="item.id"
						:label="item.name"
						:value="item.id"
						>{{ item.name }}</el-option
					>
				</el-select>
			</el-form-item>
			<el-form-item label="商品类型" prop="goods_type">
				<el-radio-group v-model="form.goods_type" @change="goods_Type">
					<el-radio :label="0">实物商品</el-radio>
					<el-radio :label="1">优惠券</el-radio>
					<el-radio :label="2">余额</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="优惠券" v-if="form.goods_type == 1">
				<div style="display: flex; flex-wrap: wrap">
					<el-tag style="margin-bottom: 5px; margin-right: 5px">
						{{ couponName }}
						<span>
							<span class="colorRed">×</span>
							1 张</span
						>
					</el-tag>
					<el-button type="primary" @click="cx" style="height: 35px"
						>重选</el-button
					>
				</div>
			</el-form-item>
			<el-form-item label="图片上传" v-if="form.goods_type == 0">
				<!-- <el-upload
          class="avatar-uploader"
          action="#"
          list-type="picture-card"
          :file-list="fileList"
          :show-file-list="false"
          :http-request="
            (file) => {
              return upload_index_img(file);
            }
          "
          style="background: #fff"
        >
          <img v-if="fileList.length > 0" :src="fileList" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload> -->
				<el-upload
					v-if="show == 1"
					action="#"
					ref="upload"
					:http-request="
						(file) => {
							return upload_index_img(file);
						}
					"
					:file-list="fileList"
					list-type="picture-card"
					:on-remove="handleRemove"
				>
					<i class="el-icon-plus"></i>
				</el-upload>
				<el-upload
					v-else
					action="#"
					ref="upload"
					:http-request="
						(file) => {
							return upload_index_img(file);
						}
					"
					list-type="picture-card"
					:on-remove="handleRemove"
				>
					<i class="el-icon-plus"></i>
				</el-upload>
			</el-form-item>

			<el-form-item label="余额" prop="balances" v-if="form.goods_type == 2">
				<el-input
					type="number"
					v-model="form.balance"
					placeholder="请输入余额"
				></el-input>
			</el-form-item>
			<el-form-item label="门店" prop="room_id">
				<el-select
					v-model="form.room_id"
					placeholder="请选择门店"
					:disabled='storeSelect.length==0'
				>
					<el-option
						v-for="item in storeSelect"
						:key="item.id"
						:label="item.name"
						:value="item.id"
						>{{ item.name }}</el-option
					>
				</el-select>
			</el-form-item>
			<el-form-item label="购买方式" prop="buy_method">
				<el-radio-group v-model="form.buy_method" @change="buy_method">
					<el-radio :label="1">积分兑换</el-radio>
					<el-radio :label="2">积分加钱购</el-radio>
					<el-radio :label="3">金钱购买</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item
				prop="credit"
				label="积分"
				v-if="form.buy_method == 2 || form.buy_method == 1"
			>
				<el-input
					type="number"
					v-model="form.credit"
					placeholder="请输入积分"
				></el-input>
			</el-form-item>
			<el-form-item
				prop="jq"
				label="金钱"
				v-if="form.buy_method == 2 || form.buy_method == 3"
			>
				<el-input
					type="number"
					v-model="form.money"
					placeholder="请输入金钱"
				></el-input>
			</el-form-item>
			<el-form-item label="库存" prop="kc">
				<el-input
					type="number"
					v-model="form.stock"
					placeholder="请输入库存"
				></el-input>
			</el-form-item>
			<el-form-item label="排序">
				<el-input
					type="number"
					v-model="form.sort"
					placeholder="排序"
				></el-input>
			</el-form-item>
			<el-form-item label="商品介绍">
				<el-input
					type="textarea"
					:autosize="{ minRows: 10, maxRows: 4 }"
					placeholder="请输入商品介绍"
					v-model="form.brife"
				>
				</el-input>
			</el-form-item>
			<!-- <el-form-item label="注意事项">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入注意事项"
          v-model="form.notice"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="兑换流程">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入兑换流程"
          v-model="form.exchange_process"
        >
        </el-input>
      </el-form-item> -->
			<el-form-item label="联盟商品">
				<el-tooltip
					:content="'Switch value: ' + form.alliance_goods"
					placement="top"
				>
					<el-switch
						v-model="form.alliance_goods"
						active-color="#13ce66"
						inactive-color="#ff4949"
						active-value="1"
						inactive-value="0"
					>
					</el-switch>
				</el-tooltip>
			</el-form-item>
			<el-form-item>
				<el-button
					type="primary"
					@click="onSubmit"
					v-text="this.$route.query.row ? '提交' : '立即创建'"
					>立即创建</el-button
				>
				<el-button @click="Rutern">返回</el-button>
			</el-form-item>
		</el-form>
		<!-- <Coupon :keys="form.goods_type"></Coupon> -->
		<el-dialog
			:visible.sync="showSelecter"
			@close="showSelecter = false"
			width="800px"
		>
			<newSelectCommodityNum
				@close="showSelecter = false"
				@getCommod="getCommod"
				:keys="1"
				:sList="sList"
				:jude="2"
			></newSelectCommodityNum>
		</el-dialog>
	</div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import { Commodity_category, addGoods, editGoods } from "@/api/market";
import { couponList } from "@/api/coupon";
import { addImage } from "@/api/comment";
import { storeSelect } from "@/api/employee";
import { mapGetters, mapActions } from "vuex";
import { BASE_URL } from "@/utils/request";
import Coupon from "../../conmpents/coupon.vue";
import QRCode from "qrcodejs2";
export default {
	computed: {
		...mapGetters(["token", "app_id", "merch_id"]),
	},
	components: {
		Coupon,
		newSelectCommodityNum,
	},
	data() {
		return {
			showSelecter: false,
			coupons: [],
			storeSelect: [],
			sList: [],
			Commodity_Category: [],
			fileList: [],
			form: {
				app_id: "",
				title: "",
				cate: "",
				goods_type: 0,
				coupon_id: "",
				balance: "",
				room_id: "",
				logo: "",
				buy_method: 1,
				credit: "",
				money: "",
				stock: "",
				sort: "",
				brife: "",
				notice: "1",
				exchange_process: "1",
				alliance_goods: "0",
			},
			couponName: "",
			show: 0,
		};
	},
	mounted() {
		this.Commodity_category();
		this.getAvailable_coupon();
		this.getMendian();
		// this.qrcode();
		if (this.$route.query.row) {
			this.show = 1;
			console.log(this.$route.query.row);
			this.fileList.push({
				uid: 1,
				url: this.$route.query.row.pic,
			});
			let arrs = Object.keys(this.form);
			arrs.map((item) => {
				this.form[item] = this.$route.query.row[item];
			});
			console.log(this.$route.query.row)
      this.storeSelect.forEach(item=>{
        if(item.id == this.form.room_id){
          this.form.room_id = item.name
        }
      })
      // this.form.room_id = this.storeSelect.find((x) => x.name).id;
      // this.form.cate = this.Commodity_Category.find((x) => x.name).id;

			if (this.$route.query.row.room_id == 0) {
				this.form.room_id = "";
			}
			if (this.$route.query.row.cate == 0) {
				this.form.cate = "";
			}
		}
	},
	methods: {
		cx() {
			this.showSelecter = true;
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
			console.log("删除", file);
			this.fileList.shift();
			this.form.logo = "";
		},
		//选择优惠券
		getCommod(data) {
			console.log("子组件传递数据", data);
			this.form.coupon_id = data[0].id;
			this.couponName = data[0].name;
			// let arrCountId = [];
			// data.forEach(item => {
			//   if (item.choseNum) {
			//     for (var n = 0; n < Number(item.choseNum); n++) {
			//       arrCountId.push(item.id);
			//     }
			//   }
			// });
			// this.sList = data;
			// this.form.reward.coupon = arrCountId.join(",");
			// this.sList = data;
			this.showSelecter = false;
			// console.log("点击", this.form.reward.coupon, this.sList);
		},
		//获取优惠券
		getAvailable_coupon() {
			if (this.$route.query.row) {
				couponList({ app_id: this.app_id }).then((res) => {
					console.log(res);
					let coupons = res.data.result;
					this.couponName = coupons.find((x) => x.id).title;
				});
			}
		},
		//提交
		onSubmit() {
			try {
				console.log(this.$route.query.row);
				if (this.$route.query.row) {

					this.form.id = this.$route.query.row.id;
          this.Commodity_Category.forEach(item=>{
            if(item.name == this.form.cate) {
              this.form.cate = item.id
            }
          })
					if (this.form.buy_method == 3) {
						this.form.credit = 0;
					}
					this.form.app_id = this.app_id;
					editGoods(this.form).then((res) => {
						console.log("bianji ", res);
						if (res.code == 200) {
							this.$message({
								message: res.msg,
								type: "success",
							});
							setTimeout(() => {
								if (this.form.goods_type == 0) {
									this.$refs.upload.clearFiles();
									this.form.logo = [];
								}
								this.$router.go(-1);
								// document.getElementById("form").reset();
							}, 100);
							// this.$emit("edit", false);
						} else {
							this.$message.error(res.msg);
						}
					});
					console.log("submit!");
				} else {
					switch (this.goods_Type) {
						case 1:
							if (this.coupons.length == 0) {
								this.$message.warning("请选择优惠券");
							} else {
								this.add_shop();
							}
							break;
						case 2:
							if (this.form.balance == "") {
								this.$message.warning("请正确输入充值余额");
							} else {
								this.add_shop();
							}
							break;
						default:
							this.add_shop();
					}
				}
			} catch (e) {
				console.log(e);
			}

			// console.log("submit!");
		},
		//返回
		Rutern() {
			this.$router.push({
				path: "/apply/newVip/13/market/marketing/salesPromotion/shellIntegral",
			});
		},
		//添加
		add_shop() {
			this.form.app_id = this.app_id;
			// this.form.logo = this.form.logo.join(",");
			addGoods(this.form).then((res) => {
				console.log("tianjia ", res);
				if (res.code == 200) {
					this.$message({
						message: res.msg,
						type: "success",
					});
					setTimeout(() => {
						document.getElementById("myform").reset();
						// if (this.form.logo) {
						// 	this.$refs.upload.clearFiles();
						// }
						this.$router.back(-1);
						this.form.logo = '';
					}, 100);
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		//商品类型
		goods_Type(val) {
			console.log(this.form.goods_type);
			if (this.form.goods_type == 1) {
				this.showSelecter = true;
				this.form.balance = "";
				this.form.logo = "";
			} else if (this.form.goods_type == 0) {
				this.form.coupon_id = "";
				this.couponName = "";
				this.form.balance = "";
			} else {
				this.form.coupon_id = "";
				this.couponName = "";
				this.form.balance = "";
				this.form.logo = "";
			}
		},
		buy_method(val) {
			console.log(this.form.buy_method);
			if (this.form.buy_method == 1) {
				this.form.credit = "";
				this.form.money = "";
			} else if (this.form.buy_method == 2) {
				this.form.credit = "";
				this.form.money = "";
			} else {
				this.form.credit = "";
				this.form.money = "";
			}
		},
		//获取商品类目
		async Commodity_category() {
			const res = await Commodity_category({
				app_id: this.app_id,
			});
			if (res.code == 200) {
				console.log(res);
				this.Commodity_Category = res.data;
			}
		},
		//获取门店
		getMendian() {
			storeSelect({ token: this.token, app_id: this.app_id }).then((res) => {
				console.log("门店", res);
        this.storeSelect = res.data;
        if(storeSelect.length == 0) {
          this.form.id = res.data[0].name
        }
			});
		},
		upload_index_img(file) {
			console.log("wenjian", file.file);
			var formdata = new FormData();
			formdata.append("token", this.token);
			formdata.append("image", file.file);
			formdata.append("type", "1");
			formdata.append("file_group", "1");
			addImage(formdata).then((res) => {
				if (res.code == 200) {
					this.fileList.shift();
					this.fileList.push({
						uid: file.uid,
						url: res.data.url,
					});
					console.log("tu", res);
					var data = res.data;
					this.form.logo = data.id;
				} else {
					this.$message.warning(res.msg);
				}
			});
		},
		// //二维码
		// qrcode() {
		// 	let text =
		// 		BASE_URL + "/shopList?token=" + this.token + "&app_id=" + this.app_id;
		// 	let qrcode = new QRCode("qrcode", {
		// 		width: 160, // 设置宽度，单位像素
		// 		height: 160, // 设置高度，单位像素
		// 		text: text,
		// 		colorDark: "#000000",
		// 		colorLight: "#ffffff",
		// 		correctLevel: 3,
		// 	});
		// },
	},
};
</script>
<style scoped>
.avatar-uploader .el-upload {
	border: 1px dashed #000;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 148px;
	height: 148px;
	line-height: 148px;
	text-align: center;
}
.avatar {
	width: 148px;
	height: 148px;
	display: block;
}
.content .upload-demo ::v-deep .el-upload–text {
	border: 1px solid black;
}
</style>
